/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Seat_MinInputs */



/**
* | output |
* | --- |
* | "(5 seat min.)" |
*
* @param {Plan_Card_Seat_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_seat_min = /** @type {((inputs?: Plan_Card_Seat_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Seat_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("(mind. 5 Plätze)")
	return /** @type {LocalizedString} */ ("(5 seat min.)")
});